export default {
  NUMBER: "Nummer",
  FIRSTNAME_LASTNAME: "Vorname, Nachname",
  SHORTFIRSTNAME_LASTNAME: "Kurzer Vorname, Nachname",
  FIRSTNAME_SHORTLASTNAME: "Vorname, Kurzer Nachname",
  SHORTFIRSTNAME_SHORTLASTNAME: "Kurzer Vorname, Kurzer Nachname",
  SALUTATION_LASTNAME: "Anrede, Nachname",
  SALUTATION_FIRSTNAME_LASTNAME: "Anrede, Vorname, Nachname",
  SALUTATION_SHORTFIRSTNAME_LASTNAME: "Anrede, Kurzer Vorname, Nachname",
  SALUTATION_SHORTLASTNAME: "Anrede, Kurzer Nachname"
};
